import logger from "./logging";
import {LOG_LEVEL} from './logger-levels';

const VueLoggerPlugin = {
  install(Vue, logger) {

    let defaultOptions = {
      logToConsole: LOG_LEVEL.OFF,
      logToServer: LOG_LEVEL.ERROR,
      applicationName: "Unspecified"
    };

    logger.options = {...defaultOptions, ...logger.options};

    let logHandler = logger

    Vue.prototype.$logger = logHandler;
  },

};

export default VueLoggerPlugin;
